import { Heading, Paragraph } from "react-ui-kit";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  width: 100%;
  height: 100%;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`;

export const H3 = styled(Heading).attrs({
  type: "h3",
})`
  margin-bottom: 5px;
`;

export const P = styled(Paragraph)``;
